import { render, staticRenderFns } from "./LocalPagination.vue?vue&type=template&id=1e026861&"
import script from "./LocalPagination.vue?vue&type=script&lang=ts&"
export * from "./LocalPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports